import React, { Component } from "react"
import { connect } from "react-redux"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import LoadingButton from "../../components/LoadingButton"
import Button from "@material-ui/core/Button"

import {
  toggleConfirmSaveShootDialog,
  toggleShootDialog,
} from "../../actions/shoots"

import Typography from "@material-ui/core/Typography"

class ConfirmSaveShootDialog extends Component {
  constructor(props) {
    super(props)
  }

  handleClose = () => {
    const { shoot } = this.props
    this.props.dispatch(toggleConfirmSaveShootDialog(false))
    this.props.dispatch(toggleShootDialog({ open: true, id: shoot.id }))
  }
  saveShoot = async () => {
    const { shoot } = this.props

    await this.props.onSaveShoot()
    this.props.dispatch(toggleConfirmSaveShootDialog(false))
    this.props.dispatch(toggleShootDialog({ open: true, id: shoot.id }))
  }
  render() {
    const { fullScreen, working } = this.props
    return (
      <Dialog
        fullScreen={fullScreen}
        open={this.props.confirmSaveShootDialogueOpen}
        onClose={this.handleClose}
        onEntered={this.setUpForm}
        onExited={this.clearState}
        aria-labelledby="responsive-dialog-title"
        disableBackdropClick
      >
        <form
          id="edit-form"
          noValidate
          autoComplete="off"
          style={{ padding: "20px" }}
        >
          <DialogTitle disableTypography style={{ textAlign: "center" }}>
            <Typography variant="h6">
              {"You have made changes to this shoot."}
            </Typography>
            <Typography variant="h6">
              {"Do you want to save before you leave ?"}
            </Typography>
          </DialogTitle>
          <DialogContent />
          <DialogActions>
            <Button variant="contained" onClick={this.handleClose}>
              Cancel
            </Button>
            <LoadingButton
              color="primary"
              variant="contained"
              buttonclicked={this.saveShoot}
              type="button"
              working={working}
            >
              Save
            </LoadingButton>
          </DialogActions>
        </form>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    confirmSaveShootDialogueOpen: state.shoots.confirmSaveShootDialogueOpen,
    client: state.clients.editClient,
  }
}
const connector = connect(mapStateToProps)

export default connector(ConfirmSaveShootDialog)
